module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('footer', [_c('a', {
    attrs: {
      "href": "#home"
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_vm._v("首页")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#list"
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_vm._v("列表")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#view"
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_vm._v("详情")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-49a5f0e8"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/FootNav/FootNav.vue
// module id = 91
// module chunks = 1